export default "__VITE_ASSET__CtnScQYY__"